export interface MapCoordinate {
  latitude: number;
  longitude: number;
}

export interface CoordinateItem extends MapCoordinate {
  id: string;
}

export interface CoordinateGroup<T extends CoordinateItem> {
  coordinate: MapCoordinate;
  items: T[];
}

export function groupItemsByCoordinate<T extends CoordinateItem>(
  items: T[],
): CoordinateGroup<T>[] {
  const groups = new Map<string, CoordinateGroup<T>>();
  for (const item of items) {
    const key = `${item.latitude}:${item.longitude}`;
    const group = groups.get(key);
    if (group) {
      group.items.push(item);
    } else {
      groups.set(key, {
        coordinate: {
          latitude: item.latitude,
          longitude: item.longitude,
        },
        items: [item],
      });
    }
  }
  return [...groups.values()];
}